import styled, { css } from 'styled-components';
import { Flex } from 'nallian-shared-ui/lib/components';

export const TemplateFlex = styled(Flex)`
  ${props =>
    !props.visible &&
    css`
      display: none;
    `}
`;
